import React, { useEffect, useState } from "react";
import Head from "next/head";
import {
  loadTestimonials,
  loadVideoPopup,
  useIsTestAgent,
  useScript,
} from "../hooks";
import appicon from "./appicon.json";
import Script from "next/script";
import NavBar from "../nav/NavBar";

const SiteHead = ({
  showNavBar,
  enableFloatingNavBar,
  disableFixed,
  isJQueryLoadedCallback = () => {},
  nonce,
}) => {
  useScript({
    type: "application/ld+json",
    textContent: appicon,
  });

  const isTestAgent = useIsTestAgent();
  const [isJQueryLoaded, setIsJQueryLoaded] = useState(false);
  const [isMobileMenuLoaded, setIsMobileMenuLoaded] = useState(false);

  useEffect(() => {
    if (isJQueryLoaded && window.$) {
      isJQueryLoadedCallback();
    }
  }, [isJQueryLoaded]);

  useEffect(() => {
    if (isMobileMenuLoaded) window.loadMobileMenu();
  }, [isMobileMenuLoaded]);

  return (
    <>
      <Head>
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta httpEquiv="content-type" content="text/html; charSet=utf-8" />
        <meta name="author" content="PixelMixer" />
        <title>PixelMixer — AI Program Memory for PMs, PMOs & Scrum Masters</title>
        <meta
          name="description"
          content="Stop chasing updates. PixelMixer connects Zoom, Teams, Slack, Jira, and Confluence into one searchable program memory — so Program Managers, TPMs, and PMO leaders can find any decision, owner, or risk instantly."
        />
        <meta
          property="og:title"
          content="PixelMixer — AI Program Memory for PMs, PMOs & Scrum Masters"
        />
        <meta property="og:type" content="article" />
        <meta
          property="og:description"
          content="Stop chasing updates. PixelMixer connects Zoom, Teams, Slack, Jira, and Confluence into one searchable program memory — so Program Managers, TPMs, and PMO leaders can find any decision, owner, or risk instantly."
        />
        <meta
          property="og:image"
          content="https://www.pixelmixer.com/static/website-assets/images/custom/ai-assistant-small.jpg"
        />
        <meta property="og:url" content="https://www.pixelmixer.com/" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta charSet="UTF-8" />
        <meta httpEquiv="X-UA-Compatible" content="ie=edge" />
        <link
          rel="shortcut icon"
          href="/static/img/play-blade-only-color.png"
          type="image/x-icon"
        />
        <link
          rel="apple-touch-icon"
          sizes="180x180"
          href="/static/favicon/apple-touch-icon.png"
        />
        <link
          rel="icon"
          type="image/png"
          sizes="32x32"
          href="/static/favicon/favicon-32x32.png"
        />
        <link
          rel="icon"
          type="image/png"
          sizes="16x16"
          href="/static/favicon/favicon-16x16.png"
        />
        <link rel="manifest" href="/static/favicon/site.webmanifest" />
        <link
          rel="mask-icon"
          href="/static/favicon/safari-pinned-tab.svg"
          color="#673ab7"
        />
        <link rel="shortcut icon" href="/static/favicon/favicon.ico" />
        <meta name="msapplication-TileColor" content="#ffffff" />
      </Head>
      {!isTestAgent && (
        <>
          <Script
            src="https://www.googletagmanager.com/gtag/js?id=AW-18071694556"
            strategy="afterInteractive"
            nonce={nonce}
          ></Script>
          <Script
            src="/static/js/analytics.js"
            strategy="afterInteractive"
            nonce={nonce}
          ></Script>
          <Script
            type="module"
            src="https://unpkg.com/ionicons@7.1.0/dist/ionicons/ionicons.esm.js"
            strategy="lazyOnload"
            nonce={nonce}
          ></Script>
          <Script
            nomodule
            src="https://unpkg.com/ionicons@7.1.0/dist/ionicons/ionicons.js"
            strategy="lazyOnload"
            nonce={nonce}
          ></Script>
        </>
      )}
      <Script
        src="/static/website-assets/js/plugins/jquery-3-6-0.min.js"
        onReady={() => setIsJQueryLoaded(true)}
        nonce={nonce}
      ></Script>
      {isJQueryLoaded && (
        <>
          <Script
            src="/static/website-assets/js/plugins/bootstrap.min.js"
            nonce={nonce}
          ></Script>
          <Script
            src="/static/website-assets/js/plugins/mobilemenu.js"
            onReady={() => setIsMobileMenuLoaded(true)}
            nonce={nonce}
          ></Script>
        </>
      )}

      {/* <!--===== PRELOADER STARTS =======--> */}
      {/* <div id="preloader">
        <div className="preloader">
          <span></span>
          <span></span>
        </div>
      </div> */}
      {/* <!--===== PRELOADER ENDS =======--> */}

      {/* <!--===== PAGE PROGRESS START=======--> */}
      <div className="paginacontainer">
        <div className="progress-wrap">
          <svg
            className="progress-circle svg-content"
            width="100%"
            height="100%"
            viewBox="-1 -1 102 102"
          >
            <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98" />
          </svg>
        </div>
      </div>
      {/* <!--===== PAGE PROGRESS END=======--> */}
      {showNavBar && (
        <NavBar
          isJQueryLoaded={isJQueryLoaded}
          enableFloatingNavBar={enableFloatingNavBar}
          disableFixed={disableFixed}
        />
      )}
    </>
  );
};

export default SiteHead;
